export let TodoUsersDTO  = 
{
    "userId": 0,
    "toDoListId": 0,
    "employeePersonalInfoId": 0, // 113,
    "username": "", // "Muzamal Ali",
    "isTeamLead": false,
    "profilePicture": null,
    "designation": "", // "Junior Software Engineer",
    "todaysTotalTasks": 0,
    "todaysTotalHours": 0,
    "yesterdaysTotalTasks": 0,
    "yesterdaysTotalHours": 0,
    "weeklyTotalHours": 0,
    "monthlyTotalHours": 0,
    "availablity": 0,
    "projects": 0,
    "todayCheckin": "",// "10:00:00",
    "yesterdayCheckin": "", // "10:00:00",
    "yesterdayCheckout": "", // "19:00:00",
    "flags": 0,
    "checkIn": "", //"06:49:17.6249478",
    "checkOut": null,
    "lateTime":  "",//"01:34:00",
    "isOffBase": false,
    "toDoLists": [],
    "totalCount": 10
}


//todo users dummy data
export let todoUsersDummyData = [
    {
        "userId": 234,
        "toDoListId": 0,
        "employeePersonalInfoId": 113,
        "username": "Muzamal Ali",
        "isTeamLead": true,
        "teamLeadId" : 0,
        "profilePicture": null,
        "designation": "Junior Software Engineer",
        "todaysTotalTasks": 4,
        "todaysTotalHours": 5.40,
        "yesterdaysTotalTasks": 6,
        "yesterdaysTotalHours": 7.5,
        "weeklyTotalHours": 0,
        "monthlyTotalHours": 0,
        "availablity": 0,
        "projects": 4,
        "todayCheckin": "10:00:00",
        "yesterdayCheckin": "10:00:00",
        "yesterdayCheckout": "19:00:00",
        "flags": 0,
        "checkIn": "10:09:17 AM",
        "checkOut": null,
        "lateTime": "00:09:00",
        "isOffBase": false,
        "toDoLists": [],
        "totalCount": 103,
        "status":1,
    },
    {
        "userId": 306,
        "toDoListId": 0,
        "employeePersonalInfoId": 168,
        "username": "Umar Waqas",
        "isTeamLead": true,
        "teamLeadId" : 0,
        "profilePicture": null,
        "designation": null,
        "todaysTotalTasks": 8,
        "todaysTotalHours": 7.5,
        "yesterdaysTotalTasks": 3,
        "yesterdaysTotalHours": 7.8,
        "weeklyTotalHours": 0,
        "monthlyTotalHours": 6.17,
        "availablity": 0,
        "projects": 11,
        "todayCheckin": "10:00:00",
        "yesterdayCheckin": "10:00:00",
        "yesterdayCheckout": "19:00:00",
        "flags": 14,
        "checkIn": "10:12:39 AM",
        "checkOut": null,
        "lateTime": "00:23:00",
        "isOffBase": false,
        "toDoLists": [],
        "totalCount": 103,
        "status":1,
    },
    {
        "userId": 90,
        "toDoListId": 0,
        "employeePersonalInfoId": 40,
        "username": "Shehryar Zaheer",
        "isTeamLead": true,
        "teamLeadId" : 0,
        "profilePicture": null,
        "designation": null,
        "todaysTotalTasks": 7,
        "todaysTotalHours": 6.5,
        "yesterdaysTotalTasks": 5,
        "yesterdaysTotalHours": 5.5,
        "weeklyTotalHours": 0,
        "monthlyTotalHours": 0,
        "availablity": 0,
        "projects": 15,
        "todayCheckin": "10:00:00",
        "yesterdayCheckin": "10:00:00",
        "yesterdayCheckout": "19:00:00",
        "flags": 0,
        "checkIn": "10:17:21 AM",
        "checkOut": null,
        "lateTime": null,
        "isOffBase": false,
        "toDoLists": [],
        "totalCount": 103,
        "status":2,
    },
    {
        "userId": 91,
        "toDoListId": 0,
        "employeePersonalInfoId": 41,
        "username": "Zahid Mehmood",
        "isTeamLead": true,
        "teamLeadId" : 0,
        "teamLeadId" : 0,
        "profilePicture": null,
        "designation": "Senior Software Engineer",
        "todaysTotalTasks": 0,
        "todaysTotalHours": 0,
        "yesterdaysTotalTasks": 7,
        "yesterdaysTotalHours": 6.5,
        "weeklyTotalHours": 0,
        "monthlyTotalHours": 0,
        "availablity": 0,
        "projects": 8,
        "todayCheckin": "10:00:00",
        "yesterdayCheckin": "10:00:00",
        "yesterdayCheckout": "19:00:00",
        "flags": 0,
        "checkIn": null,
        "checkOut": null,
        "lateTime": null,
        "isOffBase": false,
        "toDoLists": [],
        "totalCount": 103,
        "status":3,
    },
    {
        "userId": 92,
        "toDoListId": 0,
        "employeePersonalInfoId": 42,
        "username": "Awais Sharafat",
        "isTeamLead": false,
        "teamLeadId" : 234,
        "profilePicture": "https://thedocappstorage.blob.core.windows.net:443/visioncollab/18122020103552_20200803_195647.jpg",
        "designation": null,
        "todaysTotalTasks": 6,
        "todaysTotalHours": 4,
        "yesterdaysTotalTasks": 12,
        "yesterdaysTotalHours":7.3 ,
        "weeklyTotalHours": 0,
        "monthlyTotalHours": 0,
        "availablity": 0,
        "projects": 45,
        "todayCheckin": "10:00:00",
        "yesterdayCheckin": "10:00:00",
        "yesterdayCheckout": "19:00:00",
        "flags": 0,
        "checkIn": "10:36:12 AM",
        "checkOut": null,
        "lateTime": null,
        "isOffBase": false,
        "toDoLists": [],
        "totalCount": 103,
        "status":2,
    },
    {
        "userId": 97,
        "toDoListId": 0,
        "employeePersonalInfoId": 46,
        "username": "Majid Hussain",
        "isTeamLead": false,
        "teamLeadId" : 306,
        "profilePicture": "https://thedocappstorage.blob.core.windows.net:443/visioncollab/02042020073705_IMG_20200402_123247.jpg",
        "designation": "Senior Software Engineer",
        "todaysTotalTasks": 8,
        "todaysTotalHours": 7.5,
        "yesterdaysTotalTasks": 5,
        "yesterdaysTotalHours": 3.9,
        "weeklyTotalHours": 0,
        "monthlyTotalHours": 0,
        "availablity": 0,
        "projects": 9,
        "todayCheckin": "10:00:00",
        "yesterdayCheckin": "10:00:00",
        "yesterdayCheckout": "19:00:00",
        "flags": 0,
        "checkIn": "09:56:37 AM",
        "checkOut": null,
        "lateTime": null,
        "isOffBase": false,
        "toDoLists": [],
        "totalCount": 103,
        "status":1,
    },
    {
        "userId": 98,
        "toDoListId": 0,
        "employeePersonalInfoId": 47,
        "username": "Umer Mushtaq",
        "isTeamLead": false,
        "teamLeadId" : 90,
        "profilePicture": "https://thedocappstorage.blob.core.windows.net:443/visioncollab/27042020100223_12524121_10209315740036636_8557267895719454411_n.jpg",
        "designation": null,
        "todaysTotalTasks": 7,
        "todaysTotalHours": 6,
        "yesterdaysTotalTasks": 9,
        "yesterdaysTotalHours": 7.5,
        "weeklyTotalHours": 0,
        "monthlyTotalHours": 0,
        "availablity": 0,
        "projects": 15,
        "todayCheckin": "10:00:00",
        "yesterdayCheckin": "10:00:00",
        "yesterdayCheckout": "19:00:00",
        "flags": 0,
        "checkIn": "10:02:09 AM",
        "checkOut": null,
        "lateTime": null,
        "isOffBase": false,
        "toDoLists": [],
        "totalCount": 103,
        "status":1,
    },
    {
        "userId": 99,
        "toDoListId": 0,
        "employeePersonalInfoId": 48,
        "username": "Zulqarnain Sarwar",
        "isTeamLead": false,
        "teamLeadId" : 91,
        "profilePicture": null,
        "designation": "Lead Software Engineer",
        "todaysTotalTasks": 11,
        "todaysTotalHours": 7.5,
        "yesterdaysTotalTasks": 8,
        "yesterdaysTotalHours": 5.5,
        "weeklyTotalHours": 0,
        "monthlyTotalHours": 0,
        "availablity": 0,
        "projects": 12,
        "todayCheckin": "10:00:00",
        "yesterdayCheckin": "10:00:00",
        "yesterdayCheckout": "19:00:00",
        "flags": 0,
        "checkIn": "10:12:28 AM",
        "checkOut": null,
        "lateTime": null,
        "isOffBase": false,
        "toDoLists": [],
        "totalCount": 103,
        "status":1,
    },
    {
        "userId": 100,
        "toDoListId": 0,
        "employeePersonalInfoId": 49,
        "username": "Amir Sohail",
        "isTeamLead": false,
        "teamLeadId" : 234,
        "profilePicture": null,
        "designation": "Junior Software Engineer",
        "todaysTotalTasks":7,
        "todaysTotalHours": 7.5,
        "yesterdaysTotalTasks": 12,
        "yesterdaysTotalHours": 7.9,
        "weeklyTotalHours": 0,
        "monthlyTotalHours": 0,
        "availablity": 0,
        "projects": 4,
        "todayCheckin": "10:00:00",
        "yesterdayCheckin": "10:00:00",
        "yesterdayCheckout": "19:00:00",
        "flags": 0,
        "checkIn": "10:26:19 AM",
        "checkOut": null,
        "lateTime": null,
        "isOffBase": false,
        "toDoLists": [],
        "totalCount": 103,
        "status":2,
    },
    {
        "userId": 101,
        "toDoListId": 0,
        "employeePersonalInfoId": 50,
        "username": "Rana Waqas Iqbal",
        "isTeamLead": false,
        "teamLeadId" : 306,
        "profilePicture": "https://thedocappstorage.blob.core.windows.net:443/visioncollab/02042020072920_IMG_5310%20(2).JPG",
        "designation": null,
        "todaysTotalTasks": 11,
        "todaysTotalHours": 7.5,
        "yesterdaysTotalTasks": 9,
        "yesterdaysTotalHours": 5.9,
        "weeklyTotalHours": 0,
        "monthlyTotalHours": 0,
        "availablity": 0,
        "projects": 1,
        "todayCheckin": "10:00:00",
        "yesterdayCheckin": "10:00:00",
        "yesterdayCheckout": "19:00:00",
        "flags": 0,
        "checkIn": "10:09:36 AM",
        "checkOut": null,
        "lateTime": null,
        "isOffBase": false,
        "toDoLists": [],
        "totalCount": 103,
        "status":1,
    },
    {
        "userId": 108,
        "toDoListId": 0,
        "employeePersonalInfoId": 56,
        "username": "Muhammad Usama",
        "isTeamLead": false,
        "teamLeadId" : 90,
        "profilePicture": "https://thedocappstorage.blob.core.windows.net:443/visioncollab/27042020074031_DSC_0545.jpg",
        "designation": "Internee Software Engineer",
        "todaysTotalTasks": 5,
        "todaysTotalHours": 0,
        "yesterdaysTotalTasks": 11,
        "yesterdaysTotalHours": 7.5,
        "weeklyTotalHours": 0,
        "monthlyTotalHours": 0,
        "availablity": 0,
        "projects": 8,
        "todayCheckin": "10:00:00",
        "yesterdayCheckin": "10:00:00",
        "yesterdayCheckout": "19:00:00",
        "flags": 1,
        "checkIn": null,
        "checkOut": null,
        "lateTime": null,
        "isOffBase": false,
        "toDoLists": [],
        "totalCount": 103,
        "status":3,
    },
    {
        "userId": 116,
        "toDoListId": 0,
        "employeePersonalInfoId": 64,
        "username": "Muhammad Nouman Amjad",
        "isTeamLead": false,
        "teamLeadId" : 91,
        "profilePicture": null,
        "designation": null,
        "todaysTotalTasks": 9,
        "todaysTotalHours": 5.3,
        "yesterdaysTotalTasks": 4,
        "yesterdaysTotalHours": 7.9,
        "weeklyTotalHours": 0,
        "monthlyTotalHours": 1,
        "availablity": 0,
        "projects": 20,
        "todayCheckin": "10:00:00",
        "yesterdayCheckin": "10:00:00",
        "yesterdayCheckout": "19:00:00",
        "flags": 0,
        "checkIn": "10:36:12 AM",
        "checkOut": null,
        "lateTime": null,
        "isOffBase": false,
        "toDoLists": [],
        "totalCount": 103,
        "status":2,
    },
    {
        "userId": 119,
        "toDoListId": 0,
        "employeePersonalInfoId": 67,
        "username": "Sharaz Haider",
        "isTeamLead": false,
        "teamLeadId" : 234,
        "profilePicture": "https://thedocappstorage.blob.core.windows.net:443/visioncollab/02042020081756_17814655_1941260936119800_5253355036766558479_o.jpg",
        "designation": "Junior Software Engineer",
        "todaysTotalTasks": 4,
        "todaysTotalHours": 7.9,
        "yesterdaysTotalTasks": 11,
        "yesterdaysTotalHours": 5.9,
        "weeklyTotalHours": 0,
        "monthlyTotalHours": 0,
        "availablity": 0,
        "projects": 0,
        "todayCheckin": "10:00:00",
        "yesterdayCheckin": "10:00:00",
        "yesterdayCheckout": "19:00:00",
        "flags": 0,
        "checkIn": "10:12:12 AM",
        "checkOut": null,
        "lateTime": null,
        "isOffBase": false,
        "toDoLists": [],
        "totalCount": 103,
        "status":1,
    },
    {
        "userId": 120,
        "toDoListId": 0,
        "employeePersonalInfoId": 68,
        "username": "Muhammad Hassan Ilyas",
        "isTeamLead": false,
        "teamLeadId" : 306,
        "profilePicture": null,
        "designation": "Junior Software Engineer",
        "todaysTotalTasks": 6,
        "todaysTotalHours": 7.8,
        "yesterdaysTotalTasks": 2,
        "yesterdaysTotalHours": 7.2,
        "weeklyTotalHours": 0,
        "monthlyTotalHours": 0,
        "availablity": 0,
        "projects": 19,
        "todayCheckin": "10:00:00",
        "yesterdayCheckin": "10:00:00",
        "yesterdayCheckout": "19:00:00",
        "flags": 1,
        "checkIn": "10:18:12 AM",
        "checkOut": null,
        "lateTime": null,
        "isOffBase": false,
        "toDoLists": [],
        "totalCount": 103,
        "status":2,
    },
    {
        "userId": 121,
        "toDoListId": 0,
        "employeePersonalInfoId": 69,
        "username": "Rafi UD  Din",
        "isTeamLead": false,
        "teamLeadId" : 90,
        "profilePicture": null,
        "designation": "Junior Software Engineer",
        "todaysTotalTasks": 0,
        "todaysTotalHours": 0,
        "yesterdaysTotalTasks": 11,
        "yesterdaysTotalHours": 6.8,
        "weeklyTotalHours": 0,
        "monthlyTotalHours": 0,
        "availablity": 0,
        "projects": 4,
        "todayCheckin": "10:00:00",
        "yesterdayCheckin": "10:00:00",
        "yesterdayCheckout": "19:00:00",
        "flags": 0,
        "checkIn": null,
        "checkOut": null,
        "lateTime": null,
        "isOffBase": false,
        "toDoLists": [],
        "totalCount": 103,
        "status":3,
    },
    {
        "userId": 152,
        "toDoListId": 0,
        "employeePersonalInfoId": 84,
        "username": "Farwa Shabbir",
        "isTeamLead": false,
        "teamLeadId" : 91,
        "profilePicture": "https://thedocappstorage.blob.core.windows.net:443/visioncollab/02042020083419_download%20(1).jpg",
        "designation": null,
        "todaysTotalTasks": 11,
        "todaysTotalHours": 7.9,
        "yesterdaysTotalTasks": 4,
        "yesterdaysTotalHours": 7.9,
        "weeklyTotalHours": 0,
        "monthlyTotalHours": 0,
        "availablity": 0,
        "projects": 4,
        "todayCheckin": "10:00:00",
        "yesterdayCheckin": "10:00:00",
        "yesterdayCheckout": "19:00:00",
        "flags": 0,
        "checkIn": "10:08:12 AM",
        "checkOut": null,
        "lateTime": null,
        "isOffBase": false,
        "toDoLists": [],
        "totalCount": 103,
        "status":1,
    },
    {
        "userId": 156,
        "toDoListId": 0,
        "employeePersonalInfoId": 85,
        "username": "Asad Abbas",
        "isTeamLead": false,
        "teamLeadId" : 234,
        "profilePicture": "https://thedocappstorage.blob.core.windows.net:443/visioncollab/23062021034315_IMG_20190323_221142.png",
        "designation": null,
        "todaysTotalTasks": 6,
        "todaysTotalHours": 7.9,
        "yesterdaysTotalTasks": 14,
        "yesterdaysTotalHours": 7.2,
        "weeklyTotalHours": 0,
        "monthlyTotalHours": 0,
        "availablity": 0,
        "projects": 21,
        "todayCheckin": "10:00:00",
        "yesterdayCheckin": "10:00:00",
        "yesterdayCheckout": "19:00:00",
        "flags": 2,
        "checkIn": "09:54:27 AM",
        "checkOut": null,
        "lateTime": null,
        "isOffBase": false,
        "toDoLists": [],
        "totalCount": 103,
        "status":1,
    },
    {
        "userId": 180,
        "toDoListId": 0,
        "employeePersonalInfoId": 93,
        "username": "Mozam Ali",
        "isTeamLead": false,
        "teamLeadId" : 306,
        "profilePicture": null,
        "designation": null,
        "todaysTotalTasks": 12,
        "todaysTotalHours": 3.9,
        "yesterdaysTotalTasks": 8,
        "yesterdaysTotalHours": 5.9,
        "weeklyTotalHours": 0,
        "monthlyTotalHours": 0,
        "availablity": 0,
        "projects": 0,
        "todayCheckin": "10:00:00",
        "yesterdayCheckin": "10:00:00",
        "yesterdayCheckout": "19:00:00",
        "flags": 1,
        "checkIn": "10:54:39 AM",
        "checkOut": null,
        "lateTime": null,
        "isOffBase": false,
        "toDoLists": [],
        "totalCount": 103,
        "status":2,
    },
    {
        "userId": 181,
        "toDoListId": 0,
        "employeePersonalInfoId": 95,
        "username": "Umer  Khan",
        "isTeamLead": false,
        "teamLeadId" : 90,
        "profilePicture": null,
        "designation": null,
        "todaysTotalTasks": 9,
        "todaysTotalHours": 7.2,
        "yesterdaysTotalTasks": 3,
        "yesterdaysTotalHours": 3.55,
        "weeklyTotalHours": 0,
        "monthlyTotalHours": 0,
        "availablity": 0,
        "projects": 2,
        "todayCheckin": "10:00:00",
        "yesterdayCheckin": "10:00:00",
        "yesterdayCheckout": "19:00:00",
        "flags": 0,
        "checkIn": "11:04:06 AM",
        "checkOut": null,
        "lateTime": null,
        "isOffBase": false,
        "toDoLists": [],
        "totalCount": 103,
        "status":2,
    },
    {
        "userId": 358,
        "toDoListId": 0,
        "employeePersonalInfoId": 194,
        "username": "asad  ali",
        "isTeamLead": false,
        "teamLeadId" : 91,
        "profilePicture": null,
        "designation": null,
        "todaysTotalTasks": 5,
        "todaysTotalHours": 0,
        "yesterdaysTotalTasks": 11,
        "yesterdaysTotalHours": 6.9,
        "weeklyTotalHours": 0,
        "monthlyTotalHours": 0,
        "availablity": 0,
        "projects": 0,
        "todayCheckin": "10:00:00",
        "yesterdayCheckin": "10:00:00",
        "yesterdayCheckout": "19:00:00",
        "flags": 0,
        "checkIn": null,
        "checkOut": null,
        "lateTime": "00:16:00",
        "isOffBase": false,
        "toDoLists": [],
        "totalCount": 103,
        "status":3,
    },
]